export const withAbortController = (WrappedComponent) => {
  return class WithAbortController extends React.Component {
    constructor(props) {
      super(props);
      this.abortControllers = new Map();
      this.isMountedRef = true;
    }

    getNewAbortSignal = (uniqueAPINameKey = 'default') => {
      if (this.abortControllers.has(uniqueAPINameKey)) {
        this.abortControllers.get(uniqueAPINameKey).abort();
      }
      const controller = new AbortController();
      this.abortControllers.set(uniqueAPINameKey, controller);
      return controller.signal;
    };

    componentWillUnmount() {
      this.abortControllers.forEach((controller) => controller.abort());
      this.isMountedRef = false;
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          getNewAbortSignal={this.getNewAbortSignal}
          isMountedRef={{ current: this.isMountedRef }}
        />
      );
    }
  };
};
